module.exports = __webpack_public_path__ + "static/media/bag.967a374d.webp";